<template lang="pug">
.v-input__wrapper(:class="{ 'v-input--edit': editMode }")
  component(
    ref="field",
    :items="field.type == 'list' || isList(field) ? $getFieldOptions(field, entity) : []"
    :is="componentType",
    :rules="rules",
    :value="local"
    :datetime="local"
    :label="$pascalToHuman($ucfirst(field && field.name))",
    :type="inputType",
    :error-messages="errors",
    @input="sendInput($event)",
    :entity="$findEntity(field && field.type)",
    :disabled="disabled || field.disabled || isDisabled(field)",
  )
  .v-input__edition(v-if="editMode")
    v-icon(
      size="20",
      :color="field.indexable ? 'black' : 'gray'",
      @click.stop="$emit('indexable', !field.indexable)"
    ) mdi-view-column
    v-icon(
      size="20",
      :color="!field.disabled ? 'black' : 'gray'",
      @click.stop="$emit('disabled', !field.disabled)"
    ) {{ field.disabled ? 'mdi-eye-off' : 'mdi-eye' }}
    v-icon(
      size="20",
      color="error",
      @click.stop="$emit('remove', field)"
    ) mdi-close-circle
</template>

<script>
import AppEntityAutocomplete from '@@/components/EntityAutocomplete.vue'
import axios from 'axios'
// To avoid issues in the next lines, we need to disable the eslint, we import
// all the input components from vuetify as workaround, due to an error using one
// of these within the "component" tag.
/* eslint-disable */
import {
  VTextField,
  VSelect,
  VDatePicker,
  VTimePicker,
  VTextarea,
  VRadio,
  VSwitch,
  VCheckbox
} from 'vuetify/lib/components'
import moment from 'moment-timezone'

export default {
  name: 'field',
  props: {
    entity: Object,
    field: Object,
    value: null,
    errors: Array,
    o: null,
    disabled: Boolean,
    editMode: Boolean
  },
  data () {
    return {
      local: this.value,// this.o , // this.value,
      items: [],
      form: false
    }
  },
  computed: {
    rules () {
      return []
    },
    inputType () {
      if (!this.field) return 'v-text-field'
      return ENV.TYPE_TO_HTMLTYPE[this.field.type.toLowerCase()]
    },
    componentType () {
      if (!this.field) return 'v-text-field'
      if (this.isList(this.field)) return 'v-select'
      return ENV.TYPE_TO_COMPONENT[this.field.type.toLowerCase()] ||
        (this.field.foreign
          ? 'app-entity-autocomplete'
          : this.field.multiple
          ? 'v-select'
          : ENV.TYPE_TO_COMPONENT.others)
    },
    patternType () {
      if (!this.field) return 'v-text-field'
      return ENV.TYPE_TO_PATTERN[this.field.type.toLowerCase()]
    }
  },
  methods: {
    isList (field) {
      try {
        return !!ENV.ENTITIES[this.entity.name].fields[this.field.name].options
      } catch {
        return false
      }
    },
    isDisabled (field) {
      try {
        return !!ENV.ENTITIES[this.entity.name].fields[this.field.name].disabled
      } catch {
        return false
      }
    },
    async load() {
      if (!this.field) return
      if (this.field.foreign) {
        this.items = (await axios.get(this.field.key.endpoint.replace('/api', ''))).data.data
      }
    }
  },
  created() {
    this.sendInput = _.debounce(function(event) {
      const send = this.componentType === 'app-entity-autocomplete' ? event.id : event;
      this.$emit('input', send);
    }, 500);
  },
  async mounted () {
    if (this.field && this.field.type === 'DateTime')
      this.local = moment(this.value).format('DD-MMM-YYYY HH:mm')
    if (this.o !== undefined)
      this.local = this.o
    this.load()
  },
  components: {
    AppEntityAutocomplete,
    VTextField,
    VSelect,
    VDatePicker,
    VTimePicker,
    VTextarea,
    VRadio,
    VSwitch,
    VCheckbox
  }
}
</script>
